import { render, staticRenderFns } from "./MerchandisingTable.vue?vue&type=template&id=48a6c528&scoped=true&"
import script from "./MerchandisingTable.vue?vue&type=script&lang=js&"
export * from "./MerchandisingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a6c528",
  null
  
)

export default component.exports